/* ==========================================================================
   OliveDrab — product gallery
   Thumbnail sync, magnifier lens, lightbox with pinch and click zoom, and
   detail pins. Exposes OD.gallery.goTo so the variant picker can bring a
   variant's own image into view.
   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function reduced() {
    return window.OD && window.OD.prefersReduced ? window.OD.prefersReduced() : false;
  }

  var canHover = window.matchMedia('(hover: hover)').matches;

  function setup(gallery) {
    if (gallery.dataset.odGalBound) return;
    gallery.dataset.odGalBound = '1';

    var stage = $('[data-od-stage]', gallery);
    var shots = $$('[data-od-shot]', gallery);
    var thumbs = $$('[data-od-thumb]', gallery);
    if (!stage) return;

    var isRail = function () {
      return getComputedStyle(stage).overflowX !== 'visible' &&
             stage.scrollWidth > stage.clientWidth + 4;
    };

    var autoslide = null;

    /* ------------------------------------------------- thumbnail sync */

    function activate(i) {
      thumbs.forEach(function (t) {
        var on = parseInt(t.dataset.odThumb, 10) === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
      });
      var pos = $('[data-od-gal-current]', gallery);
      if (pos) pos.textContent = String(i + 1);
    }

    function goTo(i, opts) {
      opts = opts || {};
      var shot = shots[i];
      if (!shot) return;
      // any move the shopper or the variant picker asks for holds the slideshow
      if (!opts.auto && autoslide) autoslide.touch();

      if (isRail()) {
        stage.scrollTo({
          left: shot.offsetLeft - stage.offsetLeft,
          behavior: (reduced() || opts.instant) ? 'auto' : 'smooth'
        });
      } else {
        var headerH = parseInt((window.ODConfig || {}).headerHeight, 10) || 0;
        var top = shot.getBoundingClientRect().top + window.pageYOffset - headerH - 20;
        window.scrollTo({ top: top, behavior: (reduced() || opts.instant) ? 'auto' : 'smooth' });
      }
      activate(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(parseInt(t.dataset.odThumb, 10));
      });
    });

    if ('IntersectionObserver' in window && shots.length) {
      var io = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        });
        if (best) activate(parseInt(best.target.dataset.odShot, 10));
      }, { root: isRail() ? stage : null, threshold: [0.4, 0.75] });

      shots.forEach(function (s) { io.observe(s); });
    }

    // carousel arrows
    var prev = $('[data-od-gal-prev]', gallery);
    var next = $('[data-od-gal-next]', gallery);
    function currentIndex() {
      var active = thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0];
      return active ? parseInt(active.dataset.odThumb, 10) : 0;
    }
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(shots.length - 1, currentIndex() + 1)); });

    /* ------------------------------------------------------- lens zoom */

    if (gallery.dataset.zoom === 'true' && gallery.dataset.zoomMode === 'lens' && canHover) {
      $$('[data-od-zoomable]', gallery).forEach(function (frame) {
        var lens = $('[data-od-lens]', frame);
        var img = $('img', frame);
        if (!lens || !img) return;

        var scale = parseFloat(getComputedStyle(gallery).getPropertyValue('--od-zoom')) || 2.4;
        var large = frame.dataset.large || img.currentSrc || img.src;
        var loaded = false;

        function prime() {
          if (loaded) return;
          loaded = true;
          lens.style.backgroundImage = 'url("' + large + '")';
        }

        frame.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          prime();
          frame.classList.add('is-zooming');
        });

        frame.addEventListener('pointerleave', function () {
          frame.classList.remove('is-zooming');
        });

        frame.addEventListener('pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = frame.getBoundingClientRect();
          var x = e.clientX - r.left;
          var y = e.clientY - r.top;

          // keep the lens inside the frame
          var lw = lens.offsetWidth;
          var lh = lens.offsetHeight;
          var lx = Math.max(0, Math.min(r.width - lw, x - lw / 2));
          var ly = Math.max(0, Math.min(r.height - lh, y - lh / 2));

          lens.style.left = lx + 'px';
          lens.style.top = ly + 'px';
          lens.style.backgroundSize = (r.width * scale) + 'px ' + (r.height * scale) + 'px';
          lens.style.backgroundPosition =
            '-' + ((x * scale) - lw / 2) + 'px -' + ((y * scale) - lh / 2) + 'px';
        });
      });
    }

    /* -------------------------------------------------------- lightbox */

    var box = $('[data-od-lightbox]');
    if (box) {
      var lbStage = $('[data-od-lb-stage]', box);
      var lbCur = $('[data-od-lb-current]', box);
      var lbPrev = $('[data-od-lb-prev]', box);
      var lbNext = $('[data-od-lb-next]', box);
      var tpl = $('[data-od-lb-sources]');
      var sources = tpl ? $$('span', tpl.content || tpl).map(function (s) {
        return { src: s.dataset.src, w: s.dataset.w, h: s.dataset.h, alt: s.dataset.alt };
      }) : [];
      var idx = 0;
      var release = null;
      var lastFocus = null;

      function paint(i) {
        if (!sources.length) return;
        idx = Math.max(0, Math.min(sources.length - 1, i));
        var src = sources[idx];
        lbStage.innerHTML = '';
        var img = document.createElement('img');
        img.src = src.src;
        img.alt = src.alt || '';
        if (src.w) img.width = src.w;
        if (src.h) img.height = src.h;
        img.addEventListener('click', function () {
          img.classList.toggle('is-zoomed');
        });
        lbStage.appendChild(img);
        if (lbCur) lbCur.textContent = String(idx + 1);
        if (lbPrev) lbPrev.disabled = idx === 0;
        if (lbNext) lbNext.disabled = idx === sources.length - 1;
      }

      function open(i) {
        lastFocus = document.activeElement;
        box.hidden = false;
        requestAnimationFrame(function () { box.classList.add('is-open'); });
        if (window.OD && window.OD.lockScroll) window.OD.lockScroll();
        paint(i);
        if (window.OD && window.OD.focusTrap) {
          release = window.OD.focusTrap($('.od-lightbox__inner', box), close);
        }
        var c = $('[data-od-lightbox-close]', box);
        if (c) setTimeout(function () { c.focus(); }, 60);
      }

      function close() {
        box.classList.remove('is-open');
        if (window.OD && window.OD.unlockScroll) window.OD.unlockScroll();
        if (release) { release(); release = null; }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        setTimeout(function () {
          if (!box.classList.contains('is-open')) {
            box.hidden = true;
            lbStage.innerHTML = '';
          }
        }, reduced() ? 0 : 280);
      }

      $$('[data-od-open-lightbox]', gallery).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          open(parseInt(btn.dataset.odOpenLightbox, 10) || 0);
        });
      });

      /* the picture itself opens the enlarged view too. The small mark in
         the corner stays, and anything else a frame carries — a detail pin,
         a link, a button — is left to answer for itself. */
      $$('[data-od-zoomable]', gallery).forEach(function (frame) {
        var mark = $('[data-od-open-lightbox]', frame);
        if (!mark) return;
        frame.addEventListener('click', function (e) {
          if (e.target.closest('a, button, [data-od-detail-pin]')) return;
          open(parseInt(mark.dataset.odOpenLightbox, 10) || 0);
        });
      });

      $$('[data-od-lightbox-close]', box).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); close(); });
      });

      if (lbPrev) lbPrev.addEventListener('click', function () { paint(idx - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { paint(idx + 1); });

      document.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        if (e.key === 'ArrowRight') paint(idx + 1);
        if (e.key === 'ArrowLeft') paint(idx - 1);
      });
    }

    /* ----------------------------------------------------- detail pins */

    $$('[data-od-detail-pin]', gallery).forEach(function (pin) {
      pin.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = pin.getAttribute('aria-expanded') === 'true';
        $$('[data-od-detail-pin][aria-expanded="true"]').forEach(function (p) {
          p.setAttribute('aria-expanded', 'false');
        });
        pin.setAttribute('aria-expanded', String(!open));
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-od-detail-pin]')) return;
      $$('[data-od-detail-pin][aria-expanded="true"]').forEach(function (p) {
        p.setAttribute('aria-expanded', 'false');
      });
    });

    /* ------------------------------------------- phone: slides on its own

       On a phone the gallery is a sideways rail. It moves slowly to the next
       image on its own, and hands over the moment the shopper swipes, taps,
       zooms or picks a variant, picking up again only after a long rest.
       Scroll snapping is lifted while it moves, so the snap cannot fight the
       glide, and the glide is drawn frame by frame, which older Safari needs
       because it cannot smooth-scroll a scroller on request. */

    if (gallery.dataset.autoslide === 'true' && shots.length > 1) {
      autoslide = (function () {
        var mq = window.matchMedia('(max-width: 989px)');
        var hold = (parseFloat(gallery.dataset.autoslideHold) || 4) * 1000;
        var speed = parseFloat(gallery.dataset.autoslideSpeed) || 900;
        var resume = (parseFloat(gallery.dataset.autoslideResume) || 8) * 1000;

        var timer = null;
        var frame = null;
        var moving = false;
        var lastTouch = 0;
        var onScreen = true;
        var releasedAt = 0;

        function eligible() {
          return mq.matches && isRail() && !reduced() && onScreen && !document.hidden &&
                 (!box || box.hidden);
        }

        function step() {
          var a = shots[0].getBoundingClientRect();
          var b = shots[1].getBoundingClientRect();
          return Math.max(1, b.left - a.left);
        }

        function index() {
          return Math.max(0, Math.min(shots.length - 1, Math.round(stage.scrollLeft / step())));
        }

        function ease(t) {
          return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        function release() {
          stage.style.scrollSnapType = '';
          stage.style.scrollBehavior = '';
          moving = false;
          releasedAt = Date.now();
        }

        function glide(to, done) {
          var from = stage.scrollLeft;
          var start = null;
          moving = true;
          stage.style.scrollBehavior = 'auto';
          stage.style.scrollSnapType = 'none';
          function tick(now) {
            if (!moving) return;
            if (start === null) start = now;
            var t = Math.min(1, (now - start) / speed);
            stage.scrollLeft = from + (to - from) * ease(t);
            if (t < 1) {
              frame = requestAnimationFrame(tick);
            } else {
              stage.scrollLeft = to;
              // let the final position settle before snapping comes back
              setTimeout(function () { release(); if (done) done(); }, 60);
            }
          }
          frame = requestAnimationFrame(tick);
        }

        /* the last image returns to the first through a soft fade rather
           than a fast rewind across every picture */
        function fadeToStart(done) {
          moving = true;
          stage.style.transition = 'opacity ' + Math.round(speed / 2) + 'ms ease';
          stage.style.opacity = '0';
          setTimeout(function () {
            stage.style.scrollBehavior = 'auto';
            stage.style.scrollSnapType = 'none';
            stage.scrollLeft = 0;
            stage.style.opacity = '1';
            setTimeout(function () {
              stage.style.transition = '';
              stage.style.opacity = '';
              release();
              if (done) done();
            }, Math.round(speed / 2) + 40);
          }, Math.round(speed / 2));
        }

        function holdingOnVideo(i) {
          var v = shots[i] && shots[i].querySelector('video');
          return v && !v.paused && !v.ended;
        }

        function advance() {
          timer = null;
          if (!eligible() || Date.now() - lastTouch < resume) { schedule(); return; }
          var i = index();
          if (holdingOnVideo(i)) { schedule(); return; }
          var next = i + 1;
          var after = function () { activate(index()); schedule(); };
          if (next >= shots.length) fadeToStart(after);
          else glide(next * step(), after);
          activate(next >= shots.length ? 0 : next);
        }

        function schedule() {
          clearTimeout(timer);
          timer = setTimeout(advance, hold);
        }

        function stop() {
          clearTimeout(timer);
          timer = null;
          if (moving) {
            cancelAnimationFrame(frame);
            stage.style.transition = '';
            stage.style.opacity = '';
            release();
          }
        }

        function touch() {
          lastTouch = Date.now();
          stop();
          schedule();
        }

        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
          stage.addEventListener(type, touch, { passive: true });
        });
        // a swipe the shopper makes shows up as a scroll the script did not start
        stage.addEventListener('scroll', function () {
          // the snap settling just after a glide is not the shopper
          if (!moving && Date.now() - releasedAt > 400) lastTouch = Date.now();
        }, { passive: true });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { onScreen = e.isIntersecting; });
            if (!onScreen) stop();
            else if (!timer) schedule();
          }, { threshold: 0.25 }).observe(stage);
        }

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stop();
          else schedule();
        });

        if (mq.addEventListener) mq.addEventListener('change', function () { stop(); schedule(); });

        schedule();
        return { touch: touch, stop: stop };
      })();
    }

    /* ----------------------------------------------------------- expose */

    window.OD = window.OD || {};
    window.OD.gallery = window.OD.gallery || {};
    window.OD.gallery.goTo = goTo;

    activate(0);
  }

  function init(ctx) {
    $$('[data-od-gallery]', ctx || document).forEach(function (g) {
      try { setup(g); } catch (e) {
        if (window.console && console.warn) console.warn('[OD gallery]', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
